import React from 'react';

import ContentDivider from '../ContentDivider';

import './styles.css';

const ContentHeader = ({ content }) => {
    if (!content) return <></>;
    const maskUrl = content.icon + '?not-from-cache';

    return (
        <header className='ncs-content-header'>
            <img
                className='ncs-content-cover'
                src={content.cover}
                alt={content.island}
            />
            <ContentDivider position='top' />
            <div className='ncs-page-subtitle'>
                <div className='ncs-page-subtitle-icon'>
                    <div
                        style={{
                            maskImage: `url(${maskUrl})`,
                            WebkitMaskImage: `url(${maskUrl})`,
                        }}
                    />
                </div>
                <span
                    className='ncs-page-subtitle-text'
                    dangerouslySetInnerHTML={{
                        __html: content.excerpt,
                    }}
                />
            </div>
            <ContentDivider position='bottom' />
        </header>
    );
};

export default ContentHeader;
